import find from 'lodash-es/find';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Icon, Menu } from 'semantic-ui-react';

const RadioMenuButton = ({ values, active, onChange, ...menuProps }) => {
	const initialState = active
		? find(values, ['name', active]) || find(values, ['value', active])
		: null;
	const [activeItem, setActiveItem] = useState(initialState);
	const changeValue = newActive => {
		setActiveItem(newActive);
		onChange(newActive);
	};

	const activeItemName = activeItem && (activeItem.name || activeItem.value);
	return (
		<Menu compact className="radio-menu" {...menuProps}>
			{values
				? values.map(({ value, icon, name, disabled, ...props }) => (
						<Menu.Item
							key={`item-${value}`}
							name={name || value}
							active={!disabled && activeItemName === (name || value)}
							onClick={() =>
								changeValue({
									value,
									icon,
									name,
									...props
								})
							}
							{...props}
						>
							<div style={{ textAlign: 'center', width: '100%' }}>
								{icon ? <Icon {...icon} /> : null}
								{name || value}
							</div>
						</Menu.Item>
				  ))
				: null}
		</Menu>
	);
};

RadioMenuButton.defaultProps = {
	active: null
};
RadioMenuButton.propTypes = {
	active: PropTypes.string,
	values: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			icon: PropTypes.shape({})
		})
	).isRequired,
	onChange: PropTypes.func.isRequired
};

export default RadioMenuButton;
